var $ba8c73254c752aa8$exports = {};
/**
 * Initierar och lägger till eventlyssnare på läsknappen
 * När användaren klickar på knappen navigeras de till text.html sidan
 * @returns {void}
 */ function $ba8c73254c752aa8$var$initReadingButton() {
    const readingButton = document.getElementById('reading-button');
    if (readingButton) readingButton.addEventListener('click', ()=>{
        window.location.href = './text.html';
    });
}
$ba8c73254c752aa8$var$initReadingButton();


//# sourceMappingURL=reading.71060185.js.map
